<template>
  <div class="personal-info">
    <div class="personal-center">
      <div class="info-photo-box">
        <uploadFiles
          :previewImgWidth="'0.88rem'"
          :previewImgHeight="'0.88rem'"
          :isPersonal="true"
          v-model="userInfo.headPortrait">
          <div class="info-photo"><i class="el-icon-camera"></i></div>
        </uploadFiles>
        <!--        <el-image class="info-photo" :src="userInfo.headPortrait"></el-image>-->
      </div>
      <div class="base-info">
        <el-row>
          <el-col :span="12" class="label-value">
            <div class="c-label">姓名</div>
            <div class="c-value">{{ userInfo.username || "-" }}</div>
          </el-col>
          <el-col :span="12" class="label-value">
            <div class="c-label">身份证号</div>
            <div class="c-value">{{ userInfo.idCard || "-" }}</div>
          </el-col>
          <el-col :span="12" class="label-value">
            <div class="c-label">手机号/账号</div>
            <div class="c-value">
              {{ userInfo.phone || "-"
              }}
              <i class="el-icon-edit" @click="updatePhone()"></i>
            </div>
          </el-col>
          <el-col :span="12" class="label-value">
            <div class="c-label">登录密码</div>
            <div class="c-value">
              ************
              <i class="el-icon-edit" @click="updatePass()"></i>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <update-phone ref="updatePhone"></update-phone>
    <update-password ref="updatePassword"></update-password>
  </div>
</template>
<script>
import UpdatePhone from "./components/updatePhone.vue";
import { getUserInfo } from "@/views/login/api";
import UpdatePassword from "./components/updatePassword.vue";
import uploadFiles from "@/components/UploadFiles.vue";
import { updatePhoto } from "@/views/PersonalCenter/api";

export default {
  name: "PersonalInfo",
  components: { UpdatePassword, UpdatePhone, uploadFiles },
  data() {
    return {
      photoImage: "",
      userInfo: {},
    };
  },
  watch: {
    "userInfo.headPortrait": function (val) {
      if (val) {
        this.setPhoto(val);
      }
    },
  },
  created() {
    // this.userInfo = JSON.parse(localStorage.getItem("u"));
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      getUserInfo().then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
        }
      });
    },
    setPhoto(val) {
      updatePhoto({ fileId: val }).then((res) => {
        if (res.code === 200) {
        }
      });
    },
    updatePhone() {
      this.$refs.updatePhone.init();
    },
    updatePass() {
      this.$refs.updatePassword.init(this.userInfo.phone);
    },
  },
};
</script>

<style scoped lang="scss">
.personal-info {
  background-color: #ffffff;
  border-radius: 0.06rem;
  width: 100%;
  min-height: 50%;
  .personal-center {
    width: 6rem;
    height: 100%;
    padding: 0.2rem 0.2rem;
    .info-photo-box {
      //text-align: center;
      display: flex;
      justify-content: center;

      margin: 0.2rem 0;
      .info-photo {
        width: 0.8rem;
        height: 0.8rem;
        border-radius: 50%;
        border: 0.01rem solid #0a65f0;
        display: flex;
        color: #0a65f0;
        align-items: center;
        justify-content: center;
        font-size: 0.2rem;
      }
    }
    .el-icon-edit {
      color: #0a65f0;
      margin-left: 0.1rem;
      cursor: pointer;
    }
  }
}
</style>
